<template>
    <div class="panel-wrapper">
        <div class="panel-wrapper__title">
            <div>按照位置搜索：</div>
            <div style="color: #56a3a6" @click="reset">清除条件</div>
        </div>
        <div class="sider-scroll">
            <div class="sider-scroll__main">
                <div :class="['sider-scroll__tab sider-scroll__item', filter_tab == 'region' ? 'active' : '']"
                @click="tab('region')">
                    区域
                    <img class="sider-scroll__item_icon" src="@/assets/icons/chevron-right-sharp-light.svg"/>
                </div>
                <div :class="['sider-scroll__tab sider-scroll__item', filter_tab == 'subway' ? 'active' : '']"
                @click="tab('subway')">
                    地铁
                    <img class="sider-scroll__item_icon"
                    src="@/assets/icons/chevron-right-sharp-light.svg"/>
                </div>
            </div>
            <div class="sider-scroll__content" v-if="filter_tab == 'region'">
                <div class="sider-scroll__selector">
                    <div :class="['sider-scroll__item', filters.region == item.name ? 'active' : '']"
                    v-for="(item, index) in regions"
                    :key="index"
                    @click="district(index)">
                        <div class="sider-scroll__item_text">{{item.name}}</div>
                        <img class="sider-scroll__item_icon"
                        src="@/assets/icons/circle-check-sharp-solid.svg"/>
                    </div>
                </div>
            </div>
            <div class="sider-scroll__content" v-if="filter_tab == 'subway'">
                <div class="sider-scroll__selector">
                    <div :class="['sider-scroll__item', index == selected_line ? 'active' : '']"
                    v-for="(item, index) in subways"
                    :key="index"
                    @click="expand(index)">
                        <div class="sider-scroll__item_badge" v-if="item.count">{{item.count}}</div>
                        <div class="sider-scroll__item_text">{{item.line}}</div>
                        <img class="sider-scroll__item_icon"
                        src="@/assets/icons/chevron-right-sharp-light.svg">
                    </div>
                </div>
                <div class="sider-scroll__selector"
                style="flex: 1.2">
                    <div :class="['sider-scroll__item radio', item.selected ? 'active' : '', total_selected >= 3 && !item.selected ? 'disabled' : '']"
                    v-for="(item, index) in (subways[selected_line] ? subways[selected_line].stations : [])"
                    :key="index"
                    v-show="item.name !== '全线'"
                    @click="select(index)">
                        <img class="sider-scroll__item_icon"
                        src="@/assets/icons/square-check-sharp-solid.svg"
                        v-if="item.selected"/>
                        <img class="sider-scroll__item_icon"
                        src="@/assets/icons/square-sharp-light.svg"
                        v-else/>
                        <div class="sider-scroll__item_text">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel-wrapper__footer">
            <div class="panel-wrapper__footer_btn" @click="search">
                确 定
            </div>
        </div>
    </div>
</template>

<script>
    import { getCityInfo } from '@/interface/modules/common.api'

    export default {
        props: ['filters'],
        data () {
            return {
                filter_tab: 'region',
                subways: [],
                selected_line: null,
                selected_stations: [],
                total_selected: 0,
                regions: []
            }
        },
        created () {
            if (this.filters.city) this.init()
        },
        methods: {
            init () {
                const that = this
                getCityInfo({
                    data: this.filters.city,
                    success: res => {
                        that.subways = res.subway.map(item => {
                            return {
                                line: item.line,
                                count: 0,
                                stations: item.stations.map(station => {
                                    return {
                                        ...station,
                                        selected: false
                                    }
                                })
                            }
                        }),
                        that.regions = res.region
                        that.sync()
                    }
                })
            },
            sync () {
                // 初始化地铁选择数据
                const that = this
                const lines = this.subways.map(subway => subway.line)
                const params = this.filters.stations.split(';')
                params.filter(item => item != '').map(item => {
                    // 格式化参数
                    const line = item.split(',')[0]
                    const station = item.split(',')[1]
                    // 查找对应地铁站
                    const line_index = lines.indexOf(line)
                    const stations = that.subways[line_index].stations.map(station => station.name)
                    const station_index = stations.indexOf(station)
                    if (station_index >= 0) {
                        that.subways[line_index].stations[station_index].selected = true
                        that.filter_tab = 'subway'
                    }
                })
                for (let i=0; i < this.subways.length; i++) {
                    this.count(i)
                }
            },
            tab (name) {
                this.filter_tab = name
            },
            expand (index) {
                this.selected_line = index
            },
            select (index) {
                const station = this.subways[this.selected_line].stations[index]
                if (this.total_selected < 3 || station.selected) {
                    // 如果选择全线，则其余选项全部清空，如果选择了其他任意车站，则取消选择全站
                    if (station.name == '全线' && !station.selected) {
                        this.clear(this.selected_line)
                    } else if (station.name !== '全线' && !station.selected) {
                        if (this.subways[this.selected_line].stations[0].name == '全线') {
                            this.subways[this.selected_line].stations[0].selected = false
                        }
                    }
                    this.subways[this.selected_line].stations[index].selected = !station.selected
                    this.count(this.selected_line)
                }
            },
            clear (line) {
                const length = this.subways[line].stations.length
                for (let i=0; i < length; i++) {
                    this.subways[line].stations[i].selected = false
                }
            },
            count (line) {
                let total = 0
                const stations = this.subways[line].stations
                if (stations[0].name == '全线' && stations[0].selected) {
                    total = '全线'
                } else {
                    for (let i=0; i < stations.length; i++) {
                        if (stations[i].selected) total++
                    }
                }
                this.subways[line].count = total
                let whole = 0
                for (let i = 0; i < this.subways.length ;i++) {
                    whole += this.subways[i].count
                }
                this.total_selected = whole
            },
            district (index) {
                const region = this.regions[index]
                this.$emit('search', {
                    region: region.name,
                    stations: ''
                })
            },
            search () {
                const stations = []
                this.subways.map(subway => {
                    if (subway.count != 0) {
                        subway.stations.map(station => {
                            if (station.selected) stations.push(`${subway.line},${station.name}`)
                        })
                    }
                })
                this.$emit('search', {
                    region: '',
                    stations: stations.join(';')
                })
            },
            reset () {
                if (this.filter_tab == 'region') {
                    this.$emit('search', {
                        region: '',
                        stations: ''
                    })
                } else {
                    for (let i=0; i < this.subways.length; i++) {
                        this.clear(i)
                        this.count(i)
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .sider-scroll {
        padding: 10px 0;
        display: flex;
        flex: 1;
        min-height: 0;
        font-size: 11pt;
        .sider-scroll__tab {
            width: 60px;
        }
        .sider-scroll__item {
            padding: 10px 15px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            transition: all ease .3s;
            position: relative;
            .sider-scroll__item_text {
                flex: 1;
            }
            .sider-scroll__item_icon {
                width: 14px;
                height: 16px;
                opacity: 0;
                transition: all ease .3s;
                box-sizing: border-box;
            }
            .sider-scroll__item_badge {
                position: absolute;
                left: 0;
                top: 0;
                font-size: 7pt;
                background-color: #08979C;
                color: #333;
                border-radius: 25px;
                min-width: 20px;
                padding: 1px 4px;
                text-align: center;
                color: #fff;
                border: 2px solid #fff;
                box-sizing: border-box;
            }
            &.active {
                background-color: #eee;
                .sider-scroll__item_icon {
                    opacity: 1;
                }
            }
            &.disabled {
                opacity: .4;
            }
            &.radio {
                padding-right: 0;
                justify-content: left;
                align-items: baseline;
                .sider-scroll__item_icon {
                    width: 14px;
                    height: 14px;
                    opacity: 1;
                    position: relative;
                    top: 1px;
                    margin-right: 5px;
                }
                &.active {
                    color: #08979C;
                    background-color: #fff;
                }
            }
        }
        .sider-scroll__content {
            display: flex;
            height: 100%;
            flex: 1;
        }
        .sider-scroll__selector {
            flex: 1;
            padding-left: 5px;
            height: 100%;
            overflow-y: auto;
        }
    }
</style>
